import React, { useEffect, useState } from 'react';
import { Icon } from '../icons';

interface Props {
  serverUrl: string;
  error: string;
  version: string;
  onRetry: () => void;
  /** Esce dall'accesso salvato e torna a email e password. */
  onUsePassword: () => void;
}

/**
 * All'accensione del PC l'app parte spesso prima della rete: qui si aspetta il server
 * riprovando da soli, senza buttare fuori chi è già collegato.
 */
export function Offline({ serverUrl, error, version, onRetry, onUsePassword }: Props) {
  const [seconds, setSeconds] = useState(5);

  useEffect(() => {
    const t = setInterval(() => {
      setSeconds((s) => {
        if (s <= 1) {
          onRetry();
          return 5;
        }
        return s - 1;
      });
    }, 1000);
    return () => clearInterval(t);
  }, [onRetry]);

  return (
    <div className="login">
      <div className="login-card lock-card">
        <div className="lock-ring warn">
          <Icon name="wifiOff" size={42} strokeWidth={1.5} />
        </div>
        <h1 style={{ margin: 0 }}>Il CRM non risponde</h1>
        <div className="error" style={{ marginTop: 4 }}>{error}</div>
        <div className="muted small" style={{ marginTop: 10 }}>Resti collegato: riprovo tra {seconds}s.</div>

        <button className="btn dark block" type="button" onClick={onRetry} style={{ marginTop: 14, padding: '11px 16px' }}>
          <Icon name="refresh" size={16} /> Riprova ora
        </button>
        <button className="btn ghost block" type="button" onClick={onUsePassword} style={{ marginTop: 8 }} title="Esci ed entra con un altro account">
          <Icon name="key" size={15} /> Cambia utente
        </button>
        <div className="muted tiny" style={{ textAlign: 'center', marginTop: 14 }}>
          v{version}
        </div>
      </div>
    </div>
  );
}
